import { render } from "./AddMilageCase.vue?vue&type=template&id=68cb3234"
import script from "./AddMilageCase.vue?vue&type=script&lang=js"
export * from "./AddMilageCase.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/AddMilageCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68cb3234"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68cb3234', __exports__)) {
    console.log('reload')
    api.reload('68cb3234', __exports__)
  }
  
  module.hot.accept("./AddMilageCase.vue?vue&type=template&id=68cb3234", () => {
    console.log('re-render')
    api.rerender('68cb3234', render)
  })

}


export default __exports__